<template>
    <canvas ref="transactions-chart"></canvas>
</template>

<script>
import _ from 'lodash'

export default {
    props: [
        'transactions',
        'currency',
        'color',
        'days',
    ],
    data() {return {
        ctx: null,
        chart: null,
        dates: [],
        dataSet: [],
        numberOfDays: this.days ? parseInt(this.days) : 31,
        options: {
            tooltips: {
                displayColors: false,
            },
            elements: {
                line: {
                    tension: 0,
                    borderWidth: 2
                },
                point: {
                    radius: 4,
                    borderWidth: 2,
                },
            },
            layout: {
                padding: {
                    top: 10,
                },
            },
            responsive: true,
            legend: {
                display: false,
                labels: {
                    fontColor: '#cccccc',
                },
            },
            scales: {
                xAxes: [
                    {
                        ticks: {
                            autoSkip: true,
                            maxTicksLimit: 15,
                            maxRotation: 0,
                        },                        
                        gridLines: {
                            display: false,
                        },
                    },
                ],
                yAxes: [
                    {
                        gridLines: {
                            display: false,
                            drawBorder: false,
                        },
                        ticks: {
                            beginAtZero: true,
                            display: false,
                            padding: 25,
                        },
                    }
                ]
            }
        }
    }},
    mounted() {
        this.dates = this.last30days()
        this.ctx = this.$refs["transactions-chart"]
        this.chart = new Line(this.ctx, {
            type: "line",
            data: {
                labels: this.dates,
                datasets: [
                    {
                    data: this.processTransactions(),
                    backgroundColor: "#ffffff",
                    borderColor: `#${this.color}`
                    }
                ]
            },
            options: this.options
        })
    },
    methods: {
        last30days() {
            return [...new Array(this.numberOfDays)]
                .map((i, idx) => dayjs().startOf("day").subtract(idx, "days").format("DD/MM"))
                .reverse()
        },
        sumTransactions(d) {
            if (d) {
                return d.reduce((total, num) => total + num) / 100
            }
            return d
        },

        processTransactions() {
            let dataSet = this.dates.map(date => 0)
            let todayEnd = new Date()
            todayEnd.setHours(23,59,59,999)

            this.transactions
                .filter(transaction => (_.includes(['PERFORMED', 'CLEARED'], transaction.status)))
                .forEach(transaction => {
                    let diff = dayjs(todayEnd).diff(transaction["created_at"], "days")
                    dataSet[diff] = dataSet[diff] || []
                    dataSet[diff].push(transaction.amount)
                })

            return dataSet
                .map(d => this.sumTransactions(d))
                .slice(0, this.numberOfDays)
                .reverse()
        }
    }
}
</script>
